export const closeButtonStyles = (isWithNavMenu: boolean) => ({
	display: 'flex',
	justifyContent: 'flex-end',
	pr: '0.5rem',
	'.MuiSvgIcon-root': {
		color: isWithNavMenu ? 'text.primary' : 'secondary.main',
	},
});
